import axios from 'axios';

const instance = axios.create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json'
    }
})

instance.interceptors.request.use(
    (config) => {
        config.headers['Authorization'] = localStorage.getItem('bearer_token')
        return config;

    },
    (error) => {
        return Promise.reject(error);
    }
)

instance.interceptors.response.use(
    (res) => {
        return res;
    },
    async (err) => {
        console.error(err)
        return Promise.reject(err)
    }
)

export default instance